import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=5622ee55&scoped=true&"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js&"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&id=5622ee55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622ee55",
  null
  
)

export default component.exports